import React from "react";
import {FormControl} from "react-bootstrap";

function FullTextSearch(props) {

    function getValue(name) {
        const filter = props.filters && props.filters.find(filter => filter.label === name)
        if (filter) {
            return filter.value
        } else {
            return ''
        }
        return ''
    }

    return (
        <div style={{maxWidth: '200px', marginRight: '20px'}}>
            <FormControl name='Fulltext' type="text" placeholder="Vyhľadať" style={{height: '35px'}} value={getValue('Fulltext')} onChange={props.filterUpdate} />
        </div>
    )
}

export default FullTextSearch
